const medications = [
    { date: new Date('8/04/2026'), medication: 'Adalimumab 40mg/0.4mL injection', source: 'Dr. D. Smith' },
    { date: new Date('7/22/2026'), medication: 'Metformin 500mg tablet', source: 'Dr. A. Johnson' },
    { date: new Date('6/30/2026'), medication: 'Fish oil 1000mg softgel', source: 'Self reported' },
    { date: new Date('5/15/2026'), medication: 'Lisinopril 10mg tablet', source: 'Dr. D. Smith' },
    { date: new Date('4/02/2026'), medication: 'Multivitamin, daily', source: 'Self reported' },
    { date: new Date('3/18/2026'), medication: 'Atorvastatin 20mg tablet', source: 'Dr. B. Wilson' },
    { date: new Date('2/28/2026'), medication: 'Omeprazole 20mg capsule', source: 'Dr. C. Rodriguez' },
    { date: new Date('2/10/2026'), medication: 'Vitamin D3 2000 IU capsule', source: 'Self reported' },
    { date: new Date('1/15/2026'), medication: 'Aspirin 81mg tablet', source: 'Dr. D. Smith' },
    { date: new Date('12/20/2025'), medication: 'Ibuprofen 400mg tablet', source: 'Self reported' },
    { date: new Date('11/30/2025'), medication: 'Azathioprine 50mg tablet', source: 'Dr. E. Martinez' },
    { date: new Date('10/25/2025'), medication: 'Prednisone 5mg tablet', source: 'Dr. D. Smith' },
    { date: new Date('9/12/2025'), medication: 'Amoxicillin 500mg capsule', source: 'Dr. F. Lee' },
    { date: new Date('8/08/2025'), medication: 'Levothyroxine 75mcg tablet', source: 'Dr. G. Patel' },
    { date: new Date('7/20/2025'), medication: 'Calcium carbonate 600mg tablet', source: 'Self reported' },
];

const tabDataFetchers = {
    medications: () => Promise.resolve(medications),
    labs: () => Promise.resolve([]),
    notes: () => Promise.resolve([]),
    immunizations: () => Promise.resolve([]),
    appointments: () => Promise.resolve([]),
};

function getPatientRecordData(activeKey) {
    const fetcher = tabDataFetchers[activeKey];
    return fetcher ? fetcher() : Promise.resolve([]);
}

export { getPatientRecordData };
